import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { UpgradePricePlan } from '@edtech-ui/constants/upgrade-price.enum';

@Component({
  selector: 'app-super-admin-institution-dialog',
  standalone: true,
  imports: [MatOptionModule,MatSelectModule,ReactiveFormsModule,MatIconModule],
  templateUrl: './super-admin-institution-dialog.component.html',
  styleUrl: './super-admin-institution-dialog.component.scss'
})
export class SuperAdminInstitutionDialogComponent {

  plans = ['Basic', 'Pro', 'Enterprise'];
  UpgradePricePlan = UpgradePricePlan;
  
  addInstitutionForm:FormGroup;

  constructor(private dialogRef: MatDialogRef<SuperAdminInstitutionDialogComponent>) {
	  this.addInstitutionForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    domain: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    plan: new FormControl('', [Validators.required]),
  });
  }

  onSubmit(): void {
    if (this.addInstitutionForm.valid) {
      console.log(this.addInstitutionForm.value);
      this.dialogRef.close(this.addInstitutionForm.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
